import * as React from 'react';
import classNames from 'classnames';

import Logo from 'components/logo/Logo';

type Props = {
  steps: Array<string>,
  activeStep: number,
  children?: React.ReactNode | null
};

class StepsProgressBar extends React.PureComponent<Props> {
  static defaultProps = {
    steps: [],
    activeStep: 1
  };

  render(): React.ReactNode {
    const { steps, activeStep, children } = this.props;
    const activeBarWidth = (100 / steps.length) * activeStep;

    const activeBarClass = classNames({
      'steps-progress-bar__bar': true,
      'steps-progress-bar__bar--active': true,
      'steps-progress-bar__bar--no-rounded': activeStep === steps.length
    });

    return (
      <div className="steps-progress-bar">
        <div className="steps-progress-bar__content">
          <div className="steps-progress-bar__title">
            <Logo color="black" type="image" style={{ marginRight: 14, flexShrink: 0 }} />
            <span>{steps[activeStep - 1]}</span>
          </div>
          {children}
        </div>
        <div className="steps-progress-bar__bar">
          <div className={activeBarClass} style={{ width: `${activeBarWidth}%` }} />
        </div>
      </div>
    );
  }
}

export default StepsProgressBar;
